var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgOutbound = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8697 2.27371C23.1356 1.48893 22.3864 0.739763 21.6016 1.00567L4.85611 6.67979C3.95793 6.98413 3.94826 8.251 4.84169 8.56901L12.1119 11.1567C12.3951 11.2575 12.6179 11.4803 12.7187 11.7635L15.3063 19.0337C15.6243 19.9271 16.8912 19.9174 17.1956 19.0192L22.8697 2.27371Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0845 13.7908C10.475 14.1814 10.475 14.8145 10.0845 15.2051L2.65989 22.6297C2.26935 23.0202 1.6362 23.0202 1.24567 22.6297C0.855145 22.2391 0.855134 21.606 1.24567 21.2155L8.6703 13.7908C9.06081 13.4003 9.69398 13.4003 10.0845 13.7908Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78121 13.4373C5.17173 13.0468 5.17174 12.4136 4.78121 12.0231C4.39068 11.6325 3.75751 11.6326 3.36699 12.0231L0.538568 14.8515C0.148027 15.242 0.148038 15.8752 0.538568 16.2657C0.929097 16.6562 1.56224 16.6563 1.95278 16.2657L4.78121 13.4373Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8523 19.0941C12.2428 19.4847 12.2428 20.1178 11.8523 20.5084L9.02385 23.3368C8.63331 23.7273 8.00016 23.7273 7.60964 23.3368C7.21911 22.9463 7.2191 22.3131 7.60964 21.9226L10.4381 19.0941C10.8286 18.7036 11.4617 18.7036 11.8523 19.0941Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOutbound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Outbound.38ded66bc5f5b630bbe9f675ba726a67.svg";